<template>
  <div>
    <the-header></the-header>

    <div class="d-flex flex-column">
      <svg data-v-30056104="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1442 163" class="logos-bg"><path data-v-30056104="" d="m-3.90909,6l48.30303,16c48.30303,16 144.90908,48 241.51514,48c96.60606,0 193.21211,-32 289.81817,-32c96.60606,0 193.21211,32 289.81817,53.3c96.60606,21.7 193.21211,31.7 289.81817,16c96.60606,-16.3 193.21211,-58.3 241.51514,-80l48.30303,-21.3l0,160l-48.30303,0c-48.30303,0 -144.90908,0 -241.51514,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -241.51514,0l-48.30303,0l0,-160z"></path></svg>
    </div>

    <router-view
      @reload-cursus="getCursus"
    ></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TheHeader from '../components/TheHeader.vue';

export default {
  name: 'Home',

  components: {
    'the-header': TheHeader,
  },

  created() {
    this.getCursus();
  },

  methods: {
    ...mapActions(['getCursus']),
  },
};
</script>

<style scoped>

svg {
  fill: #f2f5f8;
  background-color: white;
}

</style>
